import { gsap } from 'gsap';

import AudioPlayer from '../../common/audio/main';
import SystemUtils from '../../common/utils/system';


export default class GoodJob{

    constructor(){
        this.scene = GAME_REF.scene;
        this.$self = null;
        this.soundAssets = {};

        this.timer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }

    render(){
        this.$self.classList.add('-active');
        this._playAudio();

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }

    hide(){
        this.$self.classList.remove('-active');
    }

    _init(){
        this.$self = document.querySelector('.js-goodjob');
        this._createNa();
    }


    _createNa(){
        const ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3"; 

        for(let i=1; i<3; i++){
            this.soundAssets[`na${i}`] = {src:[`./assets/audio/goodjob/na${i + ext}`]};
        }
    }

    _playAudio(){
        const sound = new AudioPlayer(this.soundAssets);
        sound.load()
            .then(() => {
                sound.playSequence(['na1', 'na2'], ()=>{
                    
                    this.timer = gsap.delayedCall(3, ()=>{
                        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
                        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
                        this.timer = null;

                        window.ParentModal.render();
                    });
                })
            })
            .catch((err) => {});
    }

    _pause(){
        if(this.timer) this.timer.pause();
    }

    _resume(){
        if(this.timer) this.timer.resume();
    }
}